import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    CircularProgress,
    Typography
} from '@material-ui/core';
import { colors } from '@material-ui/core';

const styles = theme => ({
    root: {
        height: '100%'
    },
    chartContainer: {
        position: 'relative',
        height: '300px'
    },
    stats: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    },
    device: {
        textAlign: 'center',
        padding: theme.spacing(1)
    },
    deviceIcon: {
        color: theme.palette.icon
    }
});

const ChartStatistic = props => {
    const { className, classes, registerDevice, loading, ...rest } = props;
    const [overview, setOverview] = useState(registerDevice)

    useEffect(() => {
        setOverview(registerDevice)
        return () => { };
    }, [registerDevice])

    const data = {
        datasets: [
            {
                data: overview.map(device => device.value),
                backgroundColor: overview.map(device => device.color),
                borderWidth: 8,
                borderColor: '#FFFFFF',
                hoverBorderColor: '#FFFFFF'
            }
        ],
        labels: overview.map(device => device.label)
    };

    const options = {
        legend: {
            display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        cutoutPercentage: 80,
        layout: { padding: 0 },
        tooltips: {
            enabled: true,
            mode: 'index',
            intersect: true,
            borderWidth: 1,
            borderColor: colors.grey[200],
            backgroundColor: '#FFFFFF',
            titleFontColor: colors.blueGrey[900],
            bodyFontColor: colors.blueGrey[600],
            footerFontColor: colors.blueGrey[600]
        }
    };

    let devices = []
    overview.map(overview =>
        devices.push({
            title: overview.label,
            value: overview.value,
            icon: overview.icon,
            color: overview.color
        })
    )

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader

                title={props.title}
            />
            <Divider />
            <CardContent>
                <div className={classes.chartContainer}>
                    <Doughnut
                        data={data}
                        options={options}
                    />
                </div>
                <div className={classes.stats}>
                    {devices.map(device => (
                        <div
                            className={classes.device}
                            key={device.title}
                        >
                            <span className={classes.deviceIcon}>{device.icon}</span>
                            <Typography variant="body1">{device.title}</Typography>
                            <Typography
                                style={{ color: device.color }}
                                variant="h5"
                            >
                                {loading ? <CircularProgress size={20} /> : device.value}

                            </Typography>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};



export default withStyles(styles, { withTheme: true })(ChartStatistic);
